import { Component, OnDestroy, OnInit } from '@angular/core';
import { CookieService } from 'src/app/services/cookie.service';
import { QuestionService, Difficulty } from 'src/app/services/question.service';
import { Language, LanguageService } from 'src/app/services/language-service.service';
import { TimerService } from 'src/app/services/timer.service';
import { Router } from '@angular/router';
import { PointsAndLivesService } from 'src/app/services/points-and-lives.service';
import { AccessibilityService } from 'src/app/services/accessibility.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-start-game-menu',
  templateUrl: './start-game-menu.component.html',
  styleUrls: ['./start-game-menu.component.css']
})
export class StartGameMenuComponent implements OnInit, OnDestroy {

  public languageChoices: Language[] =
  [
    Language.FIN,
    Language.SWE,
    Language.ENG
  ];

  public difficultyChoices: {diff: Difficulty, img: string}[] =
  [
    {diff: Difficulty.Easy, img: 'assets/images/UI/Eazy_Level.svg'},
    {diff: Difficulty.Medium, img: 'assets/images/UI/Middle_Level.svg'},
    {diff: Difficulty.Hard, img: 'assets/images/UI/Hard_Level.svg'}
  ];

  public languageText: string;
  public difficultyText: string;
  public difficultyDescription: string;

  public visualAccessibilityOn = false;
  public colorblindModeOn = false;
  public keyboardControlOn = false;

  private keyboardSubscriber: Subscription;

  constructor(private accessibilityHandler: AccessibilityService,
              private router: Router,
              public languageService: LanguageService,
              public gameService: QuestionService,
              private cookieService: CookieService,
              private timerService: TimerService,
              private questionService: QuestionService,
              private pointsAndLivesService: PointsAndLivesService) { }

  ngOnInit(): void {
    this.languageService.CheckRelevantCookieData();
    this.accessibilityHandler.CheckRelevantCookieData();
    this.chooseLanguage(Language.ENG);
    this.chooseDifficulty(Difficulty.Easy);

    this.visualAccessibilityOn = this.accessibilityHandler.highContrastAccessibilityOn;
    this.colorblindModeOn = this.accessibilityHandler.colorBlindAccessibilityOn;
    this.keyboardControlOn = this.accessibilityHandler.keyboardAccessibilityOn;
    this.keyboardSubscriber = this.accessibilityHandler.keyEventObs.subscribe(buttonPress => {

      if (!this.accessibilityHandler.keyboardAccessibilityOn) {
        return;
      }

      if (buttonPress.key === 'l' || buttonPress.key === 'L') {
        console.log(this.languageService.learnLanguage);
        switch (this.languageService.learnLanguage) {
          case Language.FIN: {
            this.chooseLanguage(Language.SWE);
            break;
          }
          case Language.SWE: {
            this.chooseLanguage(Language.ENG);
            break;
          }
          case Language.ENG: {
            this.chooseLanguage(Language.FIN);
            break;
          }
        }
        return;
      }

      if (buttonPress.key === 'd' || buttonPress.key === 'D') {
        switch (this.questionService.difficulty) {
          case Difficulty.Easy: {
            this.chooseDifficulty(Difficulty.Medium);
            break;
          }
          case Difficulty.Medium: {
            this.chooseDifficulty(Difficulty.Hard);
            break;
          }
          case Difficulty.Hard: {
            this.chooseDifficulty(Difficulty.Easy);
            break;
          }
        }
        return;
      }

      if (buttonPress.key === 'Enter') {
        this.ToGame();
      }

    });
  }

  ngOnDestroy(): void {
    this.keyboardSubscriber.unsubscribe();
  }

  public chooseLanguage(language: Language): void {
    this.languageService.learnLanguage = language;
    switch (this.languageService.learnLanguage) {
      case Language.FIN: {
        this.languageText = 'language_learn_finnish';
        break;
      }
      case Language.SWE: {
        this.languageText = 'language_learn_swedish';
        break;
      }
      case Language.ENG: {
        this.languageText = 'language_learn_english';
        break;
      }
    }
    this.languageService.SaveCurrentValues();
  }

  public chooseDifficulty(difficulty: Difficulty): void {
    this.languageService.learnDifficulty = difficulty;
    this.gameService.difficulty = difficulty;
    switch (this.gameService.difficulty){
      case Difficulty.Easy: {
        this.difficultyText = 'easy_mode';
        this.difficultyDescription = 'easy_mode_info';
        break;
      }
      case Difficulty.Medium: {
        this.difficultyText = 'intermediate_mode';
        this.difficultyDescription = 'intermediate_mode_info';
        break;
      }
      case Difficulty.Hard: {
        this.difficultyText = 'hard_mode';
        this.difficultyDescription = 'hard_mode_info';
        break;
      }
    }
    this.gameService.SaveCurrentValues();
  }

  public ToGame(): void {
    this.cookieService.RemoveAllCookies();
    this.languageService.SaveCurrentValues();
    this.questionService.SetNewGameValues();
    this.timerService.SetNewGameValues();
    this.pointsAndLivesService.SetNewGameValues();
    this.accessibilityHandler.SaveCurrentValues();
    this.router.navigate(['/game']);
  }

}
